import ButtonKaraoke from '@/context/domain/g02/g02-d03/g02-d03-p001-karaoke/components/ButtonKaraoke';
import CWImage from '@/context/global/components/g00/g00-d00-g003-cw-image-fallback';
import IconDashCircle from '@/context/global/components/Icon/IconDashCircle';
import IconLock from '@/context/global/components/Icon/IconLock/IconLock';
import IconMoveToTop from '@/context/global/components/Icon/IconMoveToTop';
import IconPlay from '@/context/global/components/Icon/IconPlay';
import { useAuthStore } from '@/context/global/stores/authStore';
import { TSong } from '@/context/global/types/song';

type SongQueueListProps = {
  playlist: TSong[];
  onSongSelect?: (index: number) => void;
  onSongRemove?: (index: number) => void;
  onMoveToTop?: (index: number) => void;
};

const SongQueueList = ({
  playlist,
  onSongSelect,
  onSongRemove,
  onMoveToTop,
}: SongQueueListProps) => {
  const { user } = useAuthStore();

  return (
    <div className="song-queue-list min-h-0 flex-1 overflow-y-auto">
      {playlist.map((song, index) => {
        const isLocked = song.conditions === 2 && user?.badge === 3;
        return (
          <div
            key={`music-queue-${index}`}
            className="hover:inset-ring-white hover:inset-ring-2 mt-1.5 flex cursor-pointer items-center gap-3 rounded-[10px] p-3 transition-colors hover:bg-white/5"
          >
            {/* Number */}
            <div className="flex w-8 flex-col items-center justify-center text-center">
              <span className="text-xl font-bold text-white md:text-2xl">
                {index + 1}
              </span>
            </div>

            {/* Thumbnail */}
            <div className="relative h-12 w-12">
              <CWImage
                fill
                src={song.coverUrl ?? ''}
                alt={song.title ?? ''}
                className="rounded-lg object-cover"
              />
              {isLocked && (
                <div className="absolute left-3 top-3 z-10 flex size-[26px] shrink-0 items-center justify-center rounded-full bg-[rgba(20,32,51,0.8)]">
                  <IconLock className="size-4 text-ais-green" />
                </div>
              )}
            </div>

            {/* Song Info */}
            <div className="min-w-0 flex-1">
              <h4 className="truncate text-xl font-semibold text-white md:text-2xl">
                {song.title}
              </h4>
              <p className="truncate text-lg text-gray-400 md:text-xl">{song.artist}</p>
            </div>

            {/* Control Buttons */}
            <div className="flex items-center gap-2">
              <ButtonKaraoke
                onClick={(e) => {
                  e.stopPropagation();
                  onSongSelect?.(index);
                }}
                className="flex h-8 w-8 items-center justify-center p-2"
                aria-label="Play"
              >
                <IconPlay size={16} className="text-white" />
              </ButtonKaraoke>

              <ButtonKaraoke
                disabled={index == 0}
                onClick={(e) => {
                  e.stopPropagation();
                  onMoveToTop?.(index);
                }}
                className="flex h-8 w-8 items-center justify-center p-2 text-white disabled:text-white/10"
                aria-label="Move to Top"
              >
                <IconMoveToTop size={16} className="" />
              </ButtonKaraoke>

              <ButtonKaraoke
                onClick={(e) => {
                  e.stopPropagation();
                  onSongRemove?.(index);
                }}
                className="flex h-8 w-8 items-center justify-center p-2 text-white"
                aria-label="Remove"
              >
                <IconDashCircle />
              </ButtonKaraoke>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SongQueueList;
